const detailsmarkstars = (state = [], action) => {
    switch (action.type) {
      case 'DETAILSMARKSTAR':
      return {
          type: "DETAILSMARKSTAR",
          detailsmarkstars: action.detailsmarkstars
        }
      default:
        return state
    }
  }
  
  export default detailsmarkstars